import { render } from "./userProfileInfo.vue?vue&type=template&id=1073f5a3&scoped=true"
import script from "./userProfileInfo.vue?vue&type=script&lang=js"
export * from "./userProfileInfo.vue?vue&type=script&lang=js"

import "./userProfileInfo.vue?vue&type=style&index=0&id=1073f5a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1073f5a3"]])

export default __exports__